import { CommonModule } from '@angular/common';
import { Component, EventEmitter, inject, Input, Output } from '@angular/core';
import { BUSINESS } from '@core/constants';
import { Router, RouterModule } from '@angular/router';
import { resolveHomeByRoles } from '@core/utils';
import { Global } from '@core/services';

@Component({
  selector: 'app-header',
  imports: [CommonModule, RouterModule],
  templateUrl: './header.html',
  styleUrl: './header.scss',
})
export class Header {
  private readonly router = inject(Router);
  private readonly global = inject(Global);
  readonly business = BUSINESS;
  @Input() menuOpen = false;
  @Output() menuToggle = new EventEmitter<void>();
  @Output() logout = new EventEmitter<void>();

  onToggleMenu(): void {
    this.menuToggle.emit();
  }

  onLogout(): void {
    this.logout.emit();
  }
  goToHome(): void {
    const roles = this.global.rol();
    const url = resolveHomeByRoles(roles || []);
    if (!url) return;
    this.router.navigateByUrl(url);
  }
}
